import { FC } from 'react'
import { IJobBase } from '@/types'
import { JobItemContentLabel } from '@components-v2/molecules/JobItemContentLabel'
import { JobAttributes } from '@components-v2/molecules/JobAttributes'
import { getDateTimeFromUtc, getUserAvatar } from '@/utils'
import { AvatarLabelGroup } from '@components-v2/molecules/AvatarLabelGroup'
import { BookarkJobIconButton } from '@components-v2/molecules/BookarkJobIconButton'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobCardContent: FC<Props> = ({ job }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.title}>{job?.title}</div>
        <div className={styles.labels}>
          <JobItemContentLabel job={job} />
        </div>
      </div>
      <div className={styles.center}>
        <JobAttributes job={job} />
      </div>
      <div className={styles.bottom}>
        {job.primaryRecruitingContact && (
          <AvatarLabelGroup
            src={getUserAvatar(job.primaryRecruitingContact)}
            text={job.primaryRecruitingContact.name}
            supportingText={getDateTimeFromUtc(job.createdAt, 'DD MMM YYYY')}
          />
        )}
      </div>
      <div className={styles.bookmarkBtn}>
        <BookarkJobIconButton job={job} />
      </div>
    </div>
  )
}
